import { render, staticRenderFns } from "./CheckPointView.vue?vue&type=template&id=633b25ac"
import script from "./CheckPointView.vue?vue&type=script&lang=js"
export * from "./CheckPointView.vue?vue&type=script&lang=js"
import style0 from "./CheckPointView.vue?vue&type=style&index=0&id=633b25ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports